import * as v from '@badrap/valita'
import { api } from 'src/api'

export const getChartOrganizations = (params: {
  organization: string
  username: string
}) =>
  api({
    schema: v
      .object({
        items: v.array(
          v.object({
            amount: v.number(),
            create_timestamp: v.string(),
            customerIdentifier: v.string(),
          }),
        ),
        result: v.literal('OK'),
      })
      .chain((r) => v.ok(r.items)),
    method: 'POST',
    url: '/getallmeteringrecords',
    body: params,
    withAuth: true,
  })

export const getChartOrganization = (params: {
  organization: string
  username: string
}) =>
  api({
    schema: v
      .object({
        items: v.array(
          v.object({
            amount: v.number(),
            create_timestamp: v.string(),
            customerIdentifier: v.string(),
          }),
        ),
        result: v.literal('OK'),
      })
      .chain((r) => v.ok(r.items)),
    method: 'POST',
    url: '/getmeteringrecordsorganization',
    body: params,
    withAuth: true,
  })
